/**
 * Name: Get song url reducer
 * Author: @Gaurav
 * Date: 23-07-2021
 */
export default function reducer(
  state = {
    status: 'uninitiated',
    result: [],
  },
  action
) {
  switch (action.type) {
    case 'GET_SONG_URL_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'GET_SONG_URL_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'GET_SONG_URL_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
